// This file was auto-generated by Fern from our API Definition.
export var RevisionGrouping;
(function (RevisionGrouping) {
    RevisionGrouping.By = {
        Artifact: "artifact",
        Variant: "variant",
    };
    RevisionGrouping.Get = {
        Latest: "latest",
    };
})(RevisionGrouping || (RevisionGrouping = {}));
